import clsx from 'clsx';
import React from 'react';
import { useTrilogyContext } from '../../../context';
import { hashClass } from '../../../helpers';
import { is } from '../../../services';
/**
 * AutoCompleteItem Component
 * @param suggestionSelected {Function} select item
 * @param active {boolean} isActive
 * - ------------------ WEB PROPERTIES -----------------------
 * @param className {string} Additionnal CSS Classes
 */
const AutoCompleteItem = ({ children, suggestionSelected, testId, item, active, }) => {
    const { styled } = useTrilogyContext();
    const [isActive, setIsActive] = React.useState(false);
    return (React.createElement("div", { onMouseOver: () => setIsActive(true), onMouseOut: () => setIsActive(false), role: 'listitem', "data-testid": testId, className: hashClass(styled, clsx('autocomplete-item', active && is('active'), isActive && is('active'))), onClick: () => (suggestionSelected ? suggestionSelected(item) : '') }, children));
};
export default AutoCompleteItem;
//# sourceMappingURL=AutoCompleteItem.js.map